import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { AdminGlobalPreferencesVM } from './AdminGlobalPreferencesVM';
import { Table } from 'reactstrap';
import './AdminGlobalPreferences.scss';
import { WaterwaySizingComp } from 'cd-eft/components/EFH2/Waterway Sizing Calulator/WaterwaySizingCalculator';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';

export const AdminGlobalPreferences = observer(() => {
  const vm = useRef(new AdminGlobalPreferencesVM()).current;

  
  
  return (
    <div className="admin-pref-container">
       {vm.isLoading && <Loader message="Loading ..." />}
      <h1>Admin : Global Preferences</h1>
      <div className="dropdown-container row">
        <div className="col-2 smaller-dd">
          <ComboBox
            idAndName="state-global"
            label="State/Global"
            aria-label="State/Global"
            valid={!vm.formValidation.stateGlobal}
            value={vm.adminGlobalPrefData.stateGlobal}
            onChange={(e) => vm.handleInputChange(e)}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            options={vm.stateGlobalOptions}
            errorMsg={''}
            required={true}
            className={vm.adminGlobalPreferencesErrorClass('stateGlobal')}
          />
        </div>
        <div className="col-2 smaller-dd">
          <ComboBox
            idAndName="state-name"
            label="State Name"
            aria-label="State Name"
            valid={!vm.formValidation.stateName}
            value={vm.adminGlobalPrefData.stateName}
            onChange={(e) => vm.handleInputChange(e)}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            options={vm.stateNameOptions}
            errorMsg={''}
            required={true}
            className={vm.adminGlobalPreferencesErrorClass('stateName')}
          />
        </div>
        <div className="col-2 smaller-dd">
          <ComboBox
            idAndName="project-type"
            label="Project Type"
            aria-label="Project Type"
            valid={!vm.formValidation.projectType}
            value={vm.adminGlobalPrefData.projectType}
            onChange={(e) => vm.handleInputChange(e)}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            options={vm.projectTypeOptions}
            errorMsg={''}
            required={true}
            className={vm.adminGlobalPreferencesErrorClass('projectType')}
          />
        </div>
        <div className="col-2 design-element-dd">
          <ComboBox
            idAndName="design-element-type"
            label="Design Element Type"
            aria-label="Design Element Type"
            valid={!vm.formValidation.designElementType}
            value={vm.adminGlobalPrefData.designElementType}
            onChange={(e) => vm.handleInputChange(e)}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            options={vm.designElementTypeOptions}
            errorMsg={''}
            required={true}
            className={vm.adminGlobalPreferencesErrorClass('designElementType')}
          />
        </div>
        <div className="col-3">
          <ComboBox
            idAndName="preferences-type-key"
            label="Preferences Type Key"
            aria-label="Preferences Type Key"
            valid={!vm.formValidation.prefTypeKey}
            value={vm.adminGlobalPrefData.prefTypeKey}
            onChange={(e) => vm.handleInputChange(e)}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            options={vm.preferenceTypeKeysOptionsAPI}
            errorMsg={''}
            required={true}
            className={vm.adminGlobalPreferencesErrorClass('prefTypeKey')}
          />
        </div>
      </div>
      <div className="accordion-conatainer">
        {vm.validatationForAccordions()? 
         <WaterwaySizingComp mode='adminGlobalPreferences' prefJson={vm.preferenceJson} prefId={vm.adminGlobalPrefData.prefTypeKey}/> : null }
      </div>
    </div>
  );
});
